/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Rounds_Choice_Group_Cut_Bo1Inputs */



/**
* | output |
* | --- |
* | "Group stage + top cut - BO1" |
*
* @param {Tournaments_Lib_Rounds_Choice_Group_Cut_Bo1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_rounds_choice_group_cut_bo1 = /** @type {((inputs?: Tournaments_Lib_Rounds_Choice_Group_Cut_Bo1Inputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Rounds_Choice_Group_Cut_Bo1Inputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppenphase + Top Cut - BO1")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Phase de groupes + top cut - BO1")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("小组赛 + 淘汰赛 - BO1")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("分組賽 + 晉級賽 - BO1")
	if (locale === "ko") return /** @type {LocalizedString} */ ("그룹 스테이지 + 상위 컷 - BO1")
	return /** @type {LocalizedString} */ ("Group stage + top cut - BO1")
});